<nav class="navbar navbar-expand navbar-light bg-white p-0 position-relative">
    <div class="container-fluid d-flex justify-content-end px-0 height-80">
        <ng-container *ngIf="user$ | async as u">
            <app-call-center
                *ngIf="modules?.twilio && u.permissions?.devFeatures?.twilio && u.callRing"></app-call-center>
        </ng-container>
        <app-template-placeholder
            [templateReplaySubject]="twilioService.barStyleTmpl$"
            class="flex-grow-1"></app-template-placeholder>
        <div class="flex-grow-0 py-2">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                <li
                    *ngIf="(user$ | async).permissions?.devFeatures?.smartSearch"
                    class="nav-item position-relative me-4"
                    class="nav-item position-relative me-4"
                    style="position: relative">
                    <app-global-search [ngClass]="{ 'inbound-call': twilioService.isLineBusy }"></app-global-search>
                </li>
                <!-- <li _ngcontent-foa-c344="" class="nav-item position-relative me-3 ng-tns-c344-0">
                    <a _ngcontent-foa-c344="" href="#" class="nav-link notif-icon ng-tns-c344-0">
                        <img _ngcontent-foa-c344="" src="assets/images/layout-sidebar.svg" class="ng-tns-c344-0">
                    </a>
                </li> -->
                <!-- <li class="nav-item position-relative me-4">
					<a class="nav-link"
						href="javascript:void(0)">
						<svg-icon [class]="'hover'"
							[svgClass]="'nav-item-icon'"
							src="assets/images/layout-sidebar.svg"></svg-icon>
					</a>
				</li> -->
                <li
                    (click)="toggleNotifications()"
                    class="nav-item position-relative me-4">
                    <div
                        *ngIf="(notifications$ | async).unread > 0"
                        class="badge badge--floating bg-danger px-1">
                        {{ (notifications$ | async).unread }}
                    </div>
                    <a
                        class="nav-link notif-icon"
                        href="javascript:void(0)">
                        <svg-icon
                            *ngIf="!notificationService.silencedNotices"
                            [class]="'hover'"
                            [svgClass]="'nav-item-icon'"
                            src="assets/images/notif-bell.svg"></svg-icon>
                        <svg-icon
                            *ngIf="notificationService.silencedNotices"
                            [class]="'hover'"
                            [svgClass]="'nav-item-icon notif-bell-off'"
                            src="assets/images/notif-bell-off.svg"></svg-icon>
                    </a>
                </li>
                <li
                    [routerLink]="['/chat']"
                    class="nav-item position-relative me-4">
                    <div
                        *ngIf="(chatStore$ | async).unread"
                        class="badge badge--floating bg-danger">
                        {{ (chatStore$ | async).unread }}
                    </div>
                    <a
                        class="nav-link"
                        href="javascript:void(0)">
                        <svg-icon
                            [class]="'hover'"
                            [svgClass]="'nav-item-icon'"
                            src="assets/images/icon-chat.svg"></svg-icon>
                    </a>
                </li>

                <li
                    _ngcontent-foa-c344
                    class="nav-item position-relative me-4 ng-tns-c344-0 header-account-bar"></li>

                <!-- <div class="btn-group" dropdown placement="right">
                    <button id="button-basic" dropdownToggle type="button" class="btn btn-primary btn-slim dropdown-toggle"
                            aria-controls="dropdown-basic">
                        {{ this.selectedSite ? this.selectedSite.name : 'Select Website' }} <span class="caret"></span>
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
                        role="menu" aria-labelledby="button-basic">
                        <li *ngFor="let site of sites" role="menuitem">
                            <a class="dropdown-item" href="javascript:void(0)" (click)="setSite(site)">
                                {{ site.name }}
                            </a>
                        </li>
                    </ul>
                </div> -->
                <li
                    appDropdown
                    class="nav-item dropdown ys-dropdown-menu">
                    <span
                        class="hover"
                        data-bs-toggle="dropdown">
                        <div class="d-flex align-items-center">
                            <svg-icon
                                [ngClass]="{
                                    outbound: twilioService.isDeviceReady,
                                    inbound: twilioService.isReadyForInbound,
                                    'on-timer': activityMonitor$$,
                                    none: !twilioService.isReadyForInbound && !twilioService.isDeviceReady
                                }"
                                [svgClass]="'nav-item-icon'"
                                src="assets/images/icon-user.svg"
                                class="hover me-2 my-status"></svg-icon>
                            <span class="text-primary me-2">
                                {{ (user$ | async).contact?.firstname }} {{ (user$ | async).contact?.surname }}
                            </span>
                            <svg-icon
                                [svgClass]="'nav-item-icon--fill'"
                                src="assets/images/icon-chevron-down.svg"
                                class="hover"></svg-icon>
                        </div>
                    </span>
                    <div class="dropdown-menu dropdown-menu-end shadow-sm p-0 g-0">
                        <ng-container *ngIf="twilioService.isDeviceReady">
                            <span
                                *ngIf="!twilioService.isReadyForInbound || activityMonitor$$"
                                (click)="enableInboundCalls()"
                                class="dropdown-item text-primary py-2 bullet -green">
                                Available
                            </span>
                            <div class="dropdown-divider m-0 mx-3"></div>
                            <span
                                *ngIf="twilioService.isReadyForInbound"
                                (click)="disableInboundCalls()"
                                class="dropdown-item text-primary py-2 bullet -red">
                                Unavailable
                            </span>
                            <div class="dropdown-divider m-0 mx-3"></div>
                            <!--<span
                                (click)="enableInboundCalls(3 * 60 * 1000)"
                                class="dropdown-item text-primary py-2 bullet">
                                After-Call Work
                                <small> Auto-off after 3 mins </small>
                            </span>-->
                        </ng-container>
                        <span
                            [routerLink]="['account']"
                            class="dropdown-item my-0 py-2 px-1 on-black">
                            Account
                        </span>
                        <div class="dropdown-divider m-0 px-3 on-black">
                            <div></div>
                        </div>
                        <span
                            (click)="logoutConfirmation()"
                            class="dropdown-item m-0 py-2 px-3 on-black">
                            <svg-icon
                                src="assets/images/icon-sing-out.svg"
                                class="hover"></svg-icon>
                            &nbsp;Sign out
                        </span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>
